/**
 * CKEditor stub module
 * Used by marionette-ui-components which still references ckeditor
 * The actual CKEditor4 library has been removed (EOL)
 */
module.exports = {};
